import { ReduxService } from 'dashboard-services/services';

import { tasksListDataScienceActions } from 'actions/modules/datascience/lists/tasks';

export const basicInitialState = {
  selectedTask: undefined,
}

export default (state = basicInitialState, action) => {
  switch (action.type) {
    case tasksListDataScienceActions.ON_CHANGE:
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    default:
      return state;
  }
}